import { render, staticRenderFns } from "./brand-item.vue?vue&type=template&id=cb4a14fe&"
import script from "./brand-item.vue?vue&type=script&lang=js&"
export * from "./brand-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports